<script lang="ts">
  import { toastState, runToastAction, dismissToast } from "../snackbar/store.svelte";
</script>

{#if toastState.visible}
  <div class="snackbar" role="status" aria-live="polite">
    <span class="msg">{toastState.message}</span>
    {#if toastState.action}
      <button class="action" onclick={runToastAction}>{toastState.action.label}</button>
    {/if}
    <button class="close" onclick={dismissToast} aria-label="Fermer">
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
{/if}

<style>
  .snackbar {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    /* Idem : le toast se pose au-dessus de la tab bar. */
    bottom: calc(env(safe-area-inset-bottom) + 68px);
    z-index: 100;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 14px;
    background: var(--fg);
    color: var(--bg);
    border-radius: 12px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.2);
    max-width: 92vw;
    min-width: 260px;
    font-family: var(--font-sans);
    font-size: 13.5px;
    letter-spacing: -0.005em;
    animation: slideup 200ms cubic-bezier(0.32, 0.72, 0, 1);
  }
  .msg { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .action {
    background: transparent;
    border: none;
    color: var(--accent);
    font: inherit;
    font-family: var(--font-sans);
    font-weight: 600;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 6px;
    -webkit-tap-highlight-color: transparent;
  }
  .action:active { background: color-mix(in srgb, var(--bg) 12%, transparent); }
  .close {
    background: transparent;
    border: none;
    color: var(--fg-subtle);
    cursor: pointer;
    padding: 4px;
    display: grid;
    place-items: center;
  }
  @keyframes slideup {
    from { transform: translate(-50%, 100%); opacity: 0; }
    to   { transform: translate(-50%, 0);    opacity: 1; }
  }
</style>
